import tenantUtils from '@utils';
import tenantConstants from '@constants';
import { t } from 'i18next';
import { isUnifiedProfolioEnabled } from '../../../utility/user';

const unifiedCreditsUpgradeOptionLabel = (product) => {
  const normalized = product?.slug;
  if (normalized === 'basic-listing') {
    return t('creditsUsageUpgradeNormalListing');
  }
  if (normalized === 'hot-listing') {
    return t('creditsUsageUpgradeFeaturedListing');
  }
  if (normalized === 'signature-listing') {
    return t('creditsUsageUpgradeEliteListing');
  }
  if (normalized === 'refresh') {
    return t('creditsUsageBoostToTopListing');
  }
  return null;
};

const getCreditsUsageFilters = (products, users, selectedPlatform) => {
  const isUnifiedCreditsUsage = isUnifiedProfolioEnabled({ featureKey: 'platFormSwitch' });
  const upgradeOptions = products
    ?.filter(
      (product) =>
        product.slug !== 'credit' && (selectedPlatform ? product?.platform_id === selectedPlatform?.id : true),
    )
    .map((product) => ({
      ...product,
      id: String(product.product_id || product.id),
    }));

  return [
    {
      queryParamKey: 'q[consumed_on_id_eq]',
      key: 'id',
      label: 'Listing ID',
      labelProps: { muted: true },
      limit: 9,
      placeholder: 'Enter Listing ID',
      type: 'input',
    },
    {
      key: 'product_id',
      queryParamKey: 'q[product_id_in][]',
      label: 'Upgrades',
      labelProps: { muted: true },
      placeholder: 'Select Upgrades',
      type: 'select',
      list: upgradeOptions,
      showTag: true,
      singleValue: true,
      getOptionLabel: (e) => {
        if (isUnifiedCreditsUsage) {
          const unifiedLabel = unifiedCreditsUpgradeOptionLabel(e);
          if (unifiedLabel != null) return unifiedLabel;
        }
        return tenantUtils.getLocalisedString(e, 'product_title');
      },
    },
    ...(users.length > 1
      ? [
          {
            key: tenantConstants.VALUE_IN_ARRAY_KEY('user_id'),
            queryParamKey: 'q[user_id_eq]',
            label: 'Users',
            labelProps: { muted: true },
            placeholder: 'Select Users',
            type: 'select',
            list: users,
            showTag: true,
            singleValue: true,
            getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'name'),
            getOptionValue: (op) => op.id.toString(),
          },
        ]
      : []),
  ];
};
export default getCreditsUsageFilters;
